const logFn: (...args: unknown[]) => void = (...args) => console.log(...args)
const red = (s: string): string => `\x1b[31m${s}\x1b[0m`

export const log = (title: unknown, ...infos: unknown[]): void => {
  if (infos.length === 0) {
    logFn(`${new Date().toISOString()} `, title)
    return
  }
  logFn(`${new Date().toISOString()} [${title}] `, ...infos)
}

export const logErr = (title: unknown, ...infos: unknown[]): void => {
  if (infos.length === 0) {
    logFn(red(`${new Date().toISOString()}  ${String(title)}`))
    return
  }
  const rest = infos.map(x => (typeof x === 'string' ? x : String(x))).join(' ')
  logFn(red(`${new Date().toISOString()} [${String(title)}]  ${rest}`))
}

export const info = log
export const error = logErr
